import {Trans} from "@lingui/react/macro";
import AppShell from "../shared/ui/AppShell";
import Header from "../shared/ui/Header";
import {Col} from "../ui/Box";

const NotFound = () => (
  <AppShell
    header={<Header title="404" backButton={{to: "/", label: <Trans id="nav.back">Back</Trans>}} />}
  >
    <Col
      align="center"
      justify="center"
      textAlign="center"
      color="secondary"
      flex="auto"
      bold
      size="16"
    >
      <Trans>Not found</Trans>
    </Col>
  </AppShell>
);

export default NotFound;
